import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { convertPxToVw } from '../../utils';
let Blank = class Blank extends Vue {
    dataChange(newData) {
        console.log(newData);
    }
    get blankStyle() {
        return {
            height: convertPxToVw(this.data.compMargin) + 'vw',
            background: this.data.bgColor,
        };
    }
    created() { }
};
tslib_1.__decorate([
    Prop()
], Blank.prototype, "data", void 0);
tslib_1.__decorate([
    Watch('data.compMargin')
], Blank.prototype, "dataChange", null);
Blank = tslib_1.__decorate([
    Component({})
], Blank);
export default Blank;
